module.exports = __webpack_public_path__ + "static/media/d10ru.133de59f.pdf";